import { render, staticRenderFns } from "./informatie-over-notarissen.vue?vue&type=template&id=7cc7c8a6"
import script from "./informatie-over-notarissen.vue?vue&type=script&lang=js"
export * from "./informatie-over-notarissen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports